import type { ReactNode } from 'react';
import classNames from 'classnames';
import Flex from '@/components/common/Flex';

/** Inline metric for RTL: value then label avoids bidi reordering when label ends in Latin (e.g. AI). */
export function RtlMetric({
  value,
  label,
  className = ''
}: {
  value: ReactNode;
  label: ReactNode;
  className?: string;
}) {
  return (
    <Flex inline alignItems="center" className={classNames('gap-1', className)}>
      <bdi className="flex-shrink-0" style={{ fontVariantNumeric: 'tabular-nums' }}>
        {value}
      </bdi>
      <span>{label}</span>
    </Flex>
  );
}

export function AiLabel({ prefix }: { prefix: string }) {
  return (
    <>
      {prefix} <bdi>AI</bdi>
    </>
  );
}

/** Single line: bold value then gray label — stacks vertically in brand rows. */
export function RtlMetricLine({
  value,
  label,
  className = ''
}: {
  value: ReactNode;
  label: ReactNode;
  className?: string;
}) {
  return (
    <Flex alignItems="center" className={classNames('gap-2', className)}>
      <bdi
        className="flex-shrink-0 fs--1 fw-bold text-1000"
        style={{ fontVariantNumeric: 'tabular-nums' }}
      >
        {value}
      </bdi>
      <span className="fs--2 text-500">{label}</span>
    </Flex>
  );
}
